import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import * as React from "react";
import { elementStyleSelector } from "../selectors";
import Component, { type HeaderElementProps } from "./component";

const mapStateToProps = (state: AppState, props: React.HTMLProps<HTMLDivElement>): HeaderElementProps => {
  const style = elementStyleSelector(state);
  return {
    style,
    ...props
  };
};

export default connectCustom(mapStateToProps, null, { forwardRef: true })(Component);
